<!-- 学员卡片 -->
<template>
  <div class="card-mentee"
       @click="clickHandle">
    <div class="card-mentee-circle"
         :class="[color]"></div>
    <h1>{{title}}</h1>
    <img :src="avatar"
         alt="学生头像">
    <div class="card-mentee-year">{{year}}</div>
    <div class="card-mentee-con"
         v-html="con">{{con}}</div>
  </div>
</template>

<script>
// less
import './card-mentee.less'
export default {
  name: 'card-mentee',
  props: {
    title: {
      default: ''
    },
    color: String,
    // validator: (value) => ['orange', 'red', 'green'].includes(value)
    year: {
      type: [Number, String]
    },
    con: {
      type: [String]
    },
    avatar: {
      default: ''
    }
  },
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {
    clickHandle () {
      this.$emit('click')
    }
  }
}
</script>
<style lang='less' scoped>
</style>
